<!--
 * @Author       : 四川华西绿舍建材有限公司
 * @Date         : 2025-06-25 15:43:01
 * @LastEditTime : 2025-07-02 09:10:10
 * @LastEditors  : yangxr
 * @Description  : 特材出库
 * @FilePath     : \icps_fb\src\views\platform\ICPS\smart\specialmaterial\specialMaterialOutbound.vue
-->
<template>
  <div class="pages_content table">
    <el-container>
      <el-header>
        <breaDcrumb />
      </el-header>
      <el-main style="display: flex">
        <div>
          <div v-show="showCardNav" class="hr"></div>
          <el-collapse-transition>
            <div v-show="showCardNav">
              <div class="search">
                <span style="display: inline-block; margin-bottom: 10px">
                  <span style="margin-right: 12px">车牌号</span>
                  <el-input v-model="tableParam.carNo" style="width: 150px" clearable />
                </span>
                <!-- <span style="margin-left: 24px">
                  <span style="margin-right: 12px">站点名称</span>
                  <el-select ref="selection" v-model="tableParam.stationId" style="width: 100px" filterable>
                    <el-option v-for="item in stationList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                  </el-select>
                </span> -->
                <span style="margin-left: 24px">
                  <span style="margin-right: 12px">特材成品名</span>
                  <el-input v-model="tableParam.productName" style="width: 150px" clearable />
                </span>
                <span style="margin-left: 24px">
                  <span style="margin-right: 12px">成品型号</span>
                  <el-input v-model="tableParam.productType" style="width: 150px" clearable />
                </span>
                <span style="margin-left: 24px">
                  <span style="margin-right: 12px">皮重时间</span>
                  <el-date-picker v-model="startTimDateEndTimDate" type="datetimerange" unlink-panels
                    value-format="yyyy-MM-dd HH:mm:ss" start-placeholder="开始时间" end-placeholder="结束时间"
                    @change="(tableParam.startTime = startTimDateEndTimDate ? startTimDateEndTimDate[0] : ''), (tableParam.endTime = startTimDateEndTimDate ? startTimDateEndTimDate[1] : '')"></el-date-picker>
                </span>
                <el-button icon="el-icon-search" size="medium" class="bottom_all"
                  @click="(tableParam.page = 1), gettableData()">查 询</el-button>
                <el-button size="medium" class="bottom_all_two" style="margin-left: 12px" @click="init()">重 置</el-button>
              </div>
            </div>
          </el-collapse-transition>
          <div class="hr"></div>
          <div class="card">
            <div v-loading="tableLoading" class="card_info" :style="style">
              <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe
                style="width: 100%" :data="tableData" tooltip-effect="dark">
                <template v-for="(item, index2) in table">
                  <el-table-column v-if="item.status" :key="index2" :label="item.label" align="center"
                    :width="item.width">
                    <template slot-scope="scope">
                      <span v-if="item.label == '过磅照片'">
                        <el-button size="mini" class="bottom_one" @click="lookPicture(scope.row)">查看</el-button>
                      </span>
                      <span v-else>{{ scope.row[item.prop] }}</span>
                    </template>
                  </el-table-column>
                </template>
              </el-table>
            </div>
          </div>
        </div>
      </el-main>
      <div class="card_bottom">
        <div class="card_bottom_left">
          <div class="top_page_totle">总共{{ total }}条</div>
          <el-pagination :current-page.sync="tableParam.page" :page-size="tableParam.pageSize"
            :page-sizes="[10, 20, 30, 40, 50, 100, 200, 500, 1000]" layout="prev,pager,sizes,next,jumper" :total="total"
            @size-change="sizeChange" @current-change="gettableData()"></el-pagination>
        </div>
        <div>
          <el-button size="mini" icon="el-icon-refresh-right" class="bottom_all_two" @click="gettableData">刷新</el-button>
        </div>
      </div>
    </el-container>
  </div>
</template>
  
<script>
import mixin from "@/mixins/ICPSmixin.js";
import { queryPage } from "@/api/smart/specialmaterial/specialMaterialOutbound.js";
import { getUserInfo } from "@/utils/auth.js";
// import { getUserAutList } from "@/api/common.js";
export default {
  components: {
  },
  mixins: [mixin],
  data() {
    return {
      table: [
        { label: "运输编号", prop: "code", status: true, width: "220" },
        { label: "需求站点", prop: "station", status: true, width: "150" },
        { label: "需求主体", prop: "neddSubject", status: true, width: "auto" },
        { label: "特材成品名称", prop: "productName", status: true, width: "150" },
        { label: "成品型号", prop: "productType", status: true, width: "150" },
        { label: "一次过磅量", prop: "firstWeighing", status: true, width: "100" },
        { label: "二次过磅量", prop: "secondWeighing", status: true, width: "100" },
        { label: "需求量", prop: "needNum", status: true, width: "80" },
        { label: "净重", prop: "recNum", status: true, width: "80" },
        { label: "一次过磅时间", prop: "firstTime", status: true, width: "133" },
        { label: "二次过磅时间", prop: "secondTime", status: true, width: "133" },
        { label: "需求时间", prop: "needTime", status: true, width: "133" },
      ],
      queryPage: queryPage,
      tableData: [],
      pagesType: 0,
      startTimDateEndTimDate: [new Date().Format("yyyy-MM-dd 00:00:00"), new Date().Format("yyyy-MM-dd 23:59:59")],
      lookPictureDig: false,
      urlList: [],
    };
  },
  watch: {
    startTimDateEndTimDate(val) {
      if (val?.length > 0) {
        this.tableParam.startTime = val[0];
        this.tableParam.endTime = val[1];
      } else {
        this.tableParam.startTime = "";
        this.tableParam.endTime = "";
      }
    },
  },
  async created() {
    this.UserInfo = await getUserInfo();
    this.tableParam = { ...this.tableParam, startTime: "", endTime: "", carNo: "", stationId: "", productName: "", dataType: 4,productType:"", };
    this.tableParam.startTime = this.startTimDateEndTimDate[0] || "";
    this.tableParam.endTime = this.startTimDateEndTimDate[1] || "";
    // this.stationList = await getUserAutList(true);
    // if (this.UserInfo.pointIds.length > 0) {
    //   this.tableParam.stationId = this.UserInfo.pointIds[0];
    // } else {
    //   this.tableParam.stationId = this.stationList[0].id;
    // }
    this.gettableData();
  },
  methods: {
    sizeChange(value) {
      this.tableParam.pageSize = value;
      this.gettableData();
    },
    /*重置数据,此方法必须存在，并且方发只重置条件*/
    init() {
      this.tableParam.carNo = "";
      this.tableParam.productName = "";
      this.tableParam.productType = "";
      this.tableParam.stationId = ''
      // if (this.UserInfo.pointIds.length > 0) {
      //   this.tableParam.stationId = this.UserInfo.pointIds[0];
      // } else {
      //   this.tableParam.stationId = this.stationList[0].id;
      // }
      this.startTimDateEndTimDate = [new Date().Format("yyyy-MM-dd 00:00:00"), new Date().Format("yyyy-MM-dd 23:59:59")]
      this.initData();
    },
  },
};
</script>
  
<style lang="scss" scoped>
.el-input,
.el-select {
  width: 240px;
}

.table_link {
  margin: 0 10px;
  color: $bg_color;
  cursor: pointer;
}

.table_link:hover {
  opacity: 0.8;
}
</style>
  